package co.maytes.standupbot.dashboard.components.feedback

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Radius
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.ariaHidden
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

@Composable
fun EmptyState(
    title: String,
    subtitle: String,
    monoSecondary: String? = null,
    ctaLabel: String? = null,
    onCta: (() -> Unit)? = null,
    icon: (@Composable () -> Unit)? = null,
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(topBottom = Spacing.x3l)
            .styleModifier { property("text-align", "center") },
        contentAlignment = Alignment.TopCenter,
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            EmptyIllustration(icon)
            SpanText(
                text = title,
                modifier = Modifier
                    .margin(top = Spacing.lg)
                    .fontSize(Typography.h3.size)
                    .fontWeight(Typography.h3.weight)
                    .color(Palette.textPrimary),
            )
            SpanText(
                text = subtitle,
                modifier = Modifier
                    .margin(top = Spacing.xs)
                    .maxWidth(420.px)
                    .fontSize(Typography.body.size)
                    .lineHeight(Typography.body.lineHeight)
                    .color(Palette.textSecondary),
            )
            if (monoSecondary != null) {
                SpanText(
                    text = monoSecondary,
                    modifier = Modifier
                        .margin(top = Spacing.sm)
                        .classNames("sb-mono-muted-italic"),
                )
            }
            if (ctaLabel != null && onCta != null) {
                Box(modifier = Modifier.margin(top = Spacing.lg)) {
                    Button(label = ctaLabel, variant = ButtonVariant.Primary, onClick = onCta)
                }
            }
        }
    }
}

@Composable
private fun EmptyIllustration(icon: (@Composable () -> Unit)?) {
    Box(
        modifier = Modifier
            .width(64.px)
            .height(64.px)
            .backgroundColor(Palette.accentSubtle)
            .borderRadius(Radius.xl)
            .styleModifier { property("border", "1px solid ${Palette.accentBorder}") },
        contentAlignment = Alignment.Center,
    ) {
        if (icon != null) {
            Box(
                modifier = Modifier
                    .ariaHidden()
                    .color(Palette.accent)
                    .styleModifier { property("display", "inline-flex") },
            ) {
                icon()
            }
        } else {
            Box(
                modifier = Modifier
                    .width(28.px)
                    .height(28.px)
                    .borderRadius(Radius.full)
                    .styleModifier { property("background", "rgba(94, 106, 210, 0.22)") },
            )
        }
    }
}
